import { Component, EventEmitter, Output } from '@angular/core';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { environment } from '../../../../environments/environment';
import { CommonUtil } from '../../../core/Utils/common-util';

@Component({
  selector: 'app-facility-connect-announcement-modal',
  templateUrl: './facility-connect-announcement-modal.component.html',
  styleUrls: ['./facility-connect-announcement-modal.component.scss'],
})
export class FacilityConnectAnnouncementModalComponent {
  public cloudBasePath: string;
  public rootScopeData: RootScopeDeclare;
  public fcAnnouncementModalTitle: string;
  public fcAnnouncementModalDescription: string;
  public fcAnnouncementModalMoreInfo: string;
  @Output() onClose: EventEmitter<any> = new EventEmitter();
  constructor(public commonUtil: CommonUtil) {}

  ngOnInit() {
    this.cloudBasePath = environment.cloudBasePath;
    this.rootScopeData = this.commonUtil.rootScopeData;
    this.fcAnnouncementModalTitle = this.commonUtil.translateText('FC.CONNECT.ANNOUNCEMENT.MODAL.TITLE');
    this.fcAnnouncementModalDescription = this.commonUtil.translateText('FC.CONNECT.ANNOUNCEMENT.MODAL.DESCRIPTION');
    this.fcAnnouncementModalMoreInfo = this.commonUtil.translateText('FC.CONNECT.ANNOUNCEMENT.MODAL.MOREINFO');
  }

  close() {
    this.onClose.emit();
  }

  updateHideFacilityConnectAnnouncementModal() {
    this.rootScopeData.popupData.fcAnnouncementBanner = false;
    this.onClose.emit();
  }
}
